import {SvgIcon} from '@mui/material';

export default function MinesIcon() {
	return (
		<SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none">
			<g id="vuesax/linear/minuscirlce">
				<path id="Vector (Stroke)" fillRule="evenodd" clip-rule="evenodd"
				      d="M1.16992 12C1.16992 6.08579 6.00571 1.25 11.9199 1.25C17.8341 1.25 22.6699 6.08579 22.6699 12C22.6699 17.9142 17.8341 22.75 11.9199 22.75C6.00571 22.75 1.16992 17.9142 1.16992 12ZM11.9199 2.75C6.83414 2.75 2.66992 6.91421 2.66992 12C2.66992 17.0858 6.83414 21.25 11.9199 21.25C17.0057 21.25 21.1699 17.0858 21.1699 12C21.1699 6.91421 17.0057 2.75 11.9199 2.75ZM7.16992 12C7.16992 11.5858 7.50571 11.25 7.91992 11.25H15.9199C16.3341 11.25 16.6699 11.5858 16.6699 12C16.6699 12.4142 16.3341 12.75 15.9199 12.75H7.91992C7.50571 12.75 7.16992 12.4142 7.16992 12Z"
				      fill="#0051DE"/>
			</g>
		</SvgIcon>
	);
}
